export default {
  "tooManySearchRequests": "बहुत अधिक खोज अनुरोध",
  "reachedTheLimitForRealTime": "आप 'रीयल-टाइम' खोज की सीमा तक पहुँच गए हैं।",
  "useTheRecentModeToExploreResults": "इस बीच, आप हमारे डेटाबेस में पहले से उपलब्ध डेटा के आधार पर परिणामों का पता लगाने के लिए 'हाल ही के' मोड का उपयोग कर सकते हैं।",
  "btnTryLaterAgain": "बाद में फिर से प्रयास करें",
  "btnUseRecentMode": "हाल ही के मोड का उपयोग करें",
  "createNewSequence": "नई अनुक्रम बनाएँ",
  "sequenceName": "अनुक्रम का नाम",
  "enterSequenceName": "अनुक्रम का नाम दर्ज करें",
  "uDontHaveEnoughCredits": "आपके पास पर्याप्त क्रेडिट नहीं हैं",
  "addMinimumCredits": "क्या आप अपनी खोज जारी रखने के लिए {count} टॉप-अप क्रेडिट (न्यूनतम रिचार्ज राशि) जोड़ना चाहेंगे?",
  "btnAddCredits": "क्रेडिट जोड़ें",
  "paymentMethodRequired": "भुगतान विधि आवश्यक है",
  "dontHaveAPaymentMethodLinkedToYourAccount": "ऐसा लगता है कि आपके खाते से कोई भुगतान विधि लिंक नहीं है।",
  "pleaseAddYourPaymentMethodToContinue": "जारी रखने के लिए कृपया अपनी भुगतान विधि जोड़ें।",
  "btnAddNow": "अभी जोड़ें",
  "creditRunningLow": "क्रेडिट कम हो रहे हैं!",
  "yourCreditIsRunningLow": "आपके क्रेडिट कम हो रहे हैं, और हम एक ऑटो टॉप-अप संसाधित नहीं कर सके।",
  "pleaseManuallyTopupYourCredit": "अपनी सेवा में रुकावट से बचने के लिए कृपया मैन्युअल रूप से अपने क्रेडिट टॉप-अप करें।",
  "btnTopup": "अभी टॉप-अप करें",
  "uHaveReachedYourLimit": "आप अपनी सीमा तक पहुँच गए हैं",
  "subscriptionTiers": "सदस्यता स्तर",
  "switchPlansSeamlessly": "योजनाओं को निर्बाध रूप से बदलें - आपके शेष क्रेडिट भविष्य में उपयोग के लिए टॉप-अप क्रेडिट के रूप में स्थानांतरित हो जाएंगे।",
  "tabMonthly": "मासिक",
  "tabAnnual": "वार्षिक",
  "tableFieldCredits": "क्रेडिट",
  "tableFieldTopupCredit": "टॉप-अप क्रेडिट",
  "tableFieldPageLimit": "पृष्ठ सीमा",
  "tableFieldExportLimit": "निर्यात सीमा",
  "tableFieldAPI": "एपीआई",
  "tableFieldRolePermission": "कस्टम भूमिका अनुमति",
  "tableFieldTeamManagement": "टीम प्रबंधन",
  "tableFieldPrice": "कीमत - प्रति उपयोगकर्ता, प्रति माह बिल किया गया",
  "tableFieldFeatures": "विशेषताएं",
  "titleTiers": "स्तर",
  "btnChangePlan": "योजना बदलें",
  "btnCurrentPlan": "वर्तमान",
  "upgradeToUnlockThisFeature": "इस सुविधा को अनलॉक करने के लिए अपग्रेड करें",
  "thisFeatureIsAvailableOnlyForUpgradedPlanUsers": "यह सुविधा केवल उन्नत योजना वाले उपयोगकर्ताओं के लिए उपलब्ध है।",
  "upgradeYourPlanToEnjoyEnhancedFunctionality": "उन्नत कार्यक्षमता का आनंद लेने और अपनी आवश्यकताओं के अनुरूप अधिक संभावनाओं को अनलॉक करने के लिए अपनी योजना को अपग्रेड करें।",
  "btnBack": "वापस",
  "btnUpgradeNow": "अभी अपग्रेड करें"
}